const map = {
	"./afinandinho_capacete.svg": 44665,
	"./controller.png": 32689,
	"./hearth.png": 70593,
	"./playgame.png": 4893,
	"assets/images/manut/afinandinho_capacete.svg": 44665,
	"assets/images/manut/controller.png": 32689,
	"assets/images/manut/hearth.png": 70593,
	"assets/images/manut/playgame.png": 4893
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82787;